import { ReactNode } from "react";

import type { JSX as EmotionJSX } from "@emotion/react/jsx-runtime";
import {
  ExperienceStatus,
  ExperienceTestType,
  ExperienceType,
  WebUiScopeType,
} from "@intelligems/ig-types";

export type ExperienceTypeListItem = {
  key: string;
  name: string | ReactNode;
  link: string;
  features: WebUiScopeType[];
  enabledIcon: EmotionJSX.Element;
  description: string;
};

export const REDIRECT_FILTER_OPTIONS = {
  matchesExactly: "matches exactly",
  contains: "contains",
  endsWith: "ends with",
  matchesRegex: "matches regex",
};
export const URL_REDIRECT_TYPE_OPTIONS = {
  fullReplacement: {
    title: "Replace Full URL",
    description: "Update the entire URL for users when the conditions are met.",
  },
  partialReplacement: {
    title: "Replace Matching Text",
    description:
      "Find and replace text in the path of the URL to generate the new URL.",
  },
};

export type TargetingSectionsType = {
  market: boolean;
  page: boolean;
  audience: boolean;
  template: boolean;
  theme: boolean;
  url: boolean;
  exclusionGroups: boolean;
};

export type ExperienceListSortOptionsFilter =
  | "createdAtTs"
  | "name"
  | "visitors"
  | "orders"
  | "revenue"
  | "status";
export type ExperienceListFiltersType = {
  search: string | null;
  status: ExperienceStatus[];
  testTypes: ExperienceTestType[];
  sortOptions?: ExperienceListSortOptionsFilter;
};

export const initialExperienceListFilters: ExperienceListFiltersType = {
  search: null,
  status: [],
  testTypes: [],
  sortOptions: "createdAtTs",
};
export const ANALYTICS_VIEW_TYPE_OPTIONS = {
  sitewide_orders: {
    title: "Sitewide - all orders included",
    description:
      "Best for sweeping price tests or tests when there is a high degree of\n interaction between the products in and out of the test",
  },
  test_orders_only: {
    title: "Test Products - only orders containing a test product",
    description:
      "Best when testing a narrow part of the catalogue that won’t likely have an\n effect on other products",
  },
};

export const REDIRECT_INTERVAL_OPTIONS = {
  redirectOneTime: {
    title: "Redirect One Time",
    description: "Only the first time a user lands on the Origin URL",
  },
  redirectEveryTime: {
    title: "Redirect Every Time",
    description: "Every time the user lands on the Origin URL",
  },
};

export type CampaignTableSummaryType = {
  value: string;
  subValues: string[];
};

export type FoundExperimentDetails = {
  name: string | undefined;
  id: string | undefined;
};
